// Reaproveita a instância compartilhada (não cria uma própria como
// transitApi.ts faz) — é ela que tem o interceptor de resposta que faz
// logout/redireciona pro /login em 401 (token expirado). Sem isso, uma
// sessão expirada nesta API faz o front achar silenciosamente que o
// usuário "não tem assinatura" em vez de pedir login de novo.
import api from './api';

export type SubscriptionStatus = 'pending' | 'authorized' | 'paused' | 'cancelled';

export interface SubscriptionPlan {
  price: number;
  tokens_per_cycle: number;
}

export interface SubscriptionInfo {
  has_subscription: boolean;
  status?: SubscriptionStatus;
  // Cancelamento é "soft": pode estar cancel_requested=true e ainda assim
  // active=true (período já pago valendo) — active é quem manda de verdade.
  active?: boolean;
  plan_amount?: number;
  tokens_per_cycle?: number;
  current_period_end?: string | null;
  cancel_requested?: boolean;
}

export interface CreateSubscriptionResponse {
  subscription_id: number;
  init_point: string;
  status: SubscriptionStatus;
}

export const subscriptionService = {
  async getPlan(): Promise<SubscriptionPlan> {
    const r = await api.get('/subscriptions/plan');
    return r.data;
  },
  async getMySubscription(): Promise<SubscriptionInfo> {
    const r = await api.get('/subscriptions/me');
    return r.data;
  },
  async createSubscription(): Promise<CreateSubscriptionResponse> {
    const r = await api.post('/subscriptions/create');
    return r.data;
  },
  async cancelSubscription(): Promise<{ ok: boolean; status: SubscriptionStatus; active_until: string | null }> {
    const r = await api.post('/subscriptions/cancel');
    return r.data;
  },
};

export default subscriptionService;
